import { FoodConfigUnknownPresencePolicy, FoodProvisioningMode } from 'types/api/foodApi.interface'

export const FOOD_PROVISIONING_MODE_OPTIONS = [
  { label: 'Mess / Hall', value: FoodProvisioningMode.MessOrHall },
  { label: 'Packout', value: FoodProvisioningMode.Packout },
  { label: 'Opt-Out', value: FoodProvisioningMode.OptOut },
]

export const FOOD_UNKNOWN_PRESENCE_OPTIONS = [
  { label: 'No Meal', value: FoodConfigUnknownPresencePolicy.NoMeal },
  { label: 'Plan Meal', value: FoodConfigUnknownPresencePolicy.PlanMeal },
  { label: 'Standby Reserve', value: FoodConfigUnknownPresencePolicy.StandbyReserve },
]

export const foodProvisioningModeLabel = (mode: number) =>
  FOOD_PROVISIONING_MODE_OPTIONS.find((o) => o.value === mode)?.label || `Mode ${mode}`
